import {
  ProfileAPIService, DataAPIService, VideoAPIService, GeofenceAPIService,
} from './AxiosAPIService';

import { logger } from './SharedService';

// get drivers
export const getDriversReport = async (fleetId: string, query: string): Promise<any> => {
  logger.info('GET', 'REQUEST', 'getDriversReport', `/fleets/${fleetId}/reports/drivers${query}`);
  const { data } = await ProfileAPIService.api.get<any>(`/fleets/${fleetId}/reports/drivers${query}`);
  logger.info('GET', 'RESPONSE', 'getDriversReport', '...file');
  return data;
};

// get vehicles
export const getVehiclesReport = async (fleetId: string, query: string): Promise<any> => {
  logger.info('GET', 'REQUEST', 'getVehiclesReport', `/fleets/${fleetId}/reports/vehicles${query}`);
  const { data } = await ProfileAPIService.api.get<any>(`/fleets/${fleetId}/reports/vehicles${query}`);
  logger.info('GET', 'RESPONSE', 'getVehiclesReport', '...file');
  return data;
};

// get devices
export const getDevicesReport = async (fleetId: string, query: string): Promise<any> => {
  logger.info('GET', 'REQUEST', 'getDevicesReport', `/fleets/${fleetId}/reports/devices${query}`);
  const { data } = await ProfileAPIService.api.get<any>(`/fleets/${fleetId}/reports/devices${query}`);
  logger.info('GET', 'RESPONSE', 'getDevicesReport', '...file');
  return data;
};

// get alerts
export const getAlertsReport = async (fleetId: string, query: string): Promise<any> => {
  logger.info('GET', 'REQUEST', 'getAlertsReport', `/${fleetId}/reports/alerts${query}`);
  const { data } = await DataAPIService.api.get<any>(`/${fleetId}/reports/alerts${query}`);
  logger.info('GET', 'RESPONSE', 'getAlertsReport', '...file');
  return data;
};

// get trips
export const getTripsReport = async (fleetId: string, query: string): Promise<any> => {
  logger.info('GET', 'REQUEST', 'getTripsReport', `${fleetId}/reports/trips${query}`);
  const { data } = await DataAPIService.api.get<any>(`${fleetId}/reports/trips${query}`);
  logger.info('GET', 'RESPONSE', 'getTripsReport', '...file');
  return data;
};

// get videos
export const getVideosReport = async (fleetId: string, query: string): Promise<any> => {
  logger.info('GET', 'REQUEST', 'getVideosReport', `/fleets/${fleetId}/reports/videos${query}`);
  const { data } = await VideoAPIService.api.get<any>(`/fleets/${fleetId}/reports/videos${query}`);
  logger.info('GET', 'RESPONSE', 'getVideosReport', '...file');
  return data;
};

// get notes
export const getNotesReport = async (fleetId: string, query: string): Promise<any> => {
  logger.info('GET', 'REQUEST', 'getNotesReport', `/${fleetId}/reports/notes${query}`);
  const { data } = await DataAPIService.api.get<any>(`/${fleetId}/reports/notes${query}`);
  logger.info('GET', 'RESPONSE', 'getNotesReport', '...file');
  return data;
};

// get geaofence events
export const getGeofenceEventsReport = async (fleetId: string, query: string): Promise<any> => {
  logger.info('GET', 'REQUEST', 'getGeofenceEventsReport', `/fleets/${fleetId}/reports/intersections${query}`);
  const { data } = await GeofenceAPIService.api.get<any>(`/fleets/${fleetId}/reports/intersections${query}`);
  logger.info('GET', 'RESPONSE', 'getGeofenceEventsReport', '...file');
  return data;
};
